import React from 'react';

import { IntegrationNames } from 'common/constants/integrations';
import { ManualSourceNames } from 'common/constants/sources';
import LazyLoadedImage from 'common/LazyLoadedImage';
import AppStoreLogo from 'img/app-store-logo-small.svg';
import AsanaLogo from 'img/asana-logo.png';
import AzureDevopsLogoSmall from 'img/azure-devops-logo-small.png';
import AzureLogo from 'img/azure-logo-icon.png';
import CapterraLogo from 'img/capterra-logo-small.svg';
import ClickupLogo from 'img/clickup-logo.png';
import DiscordLogoSmall from 'img/discord-logo-small.png';
import FreshdeskLogo from 'img/freshdesk-logo-small.svg';
import G2Logo from 'img/g2-logo-small.svg';
import GitHubLogo from 'img/github-logo-icon.png';
import GongLogoSmall from 'img/gong-logo-small.png';
import GooglePlayLogo from 'img/google-play-logo-small.svg';
import HelpscoutLogoSmall from 'img/helpscout-logo-small.png';
import HubspotLogoSmall from 'img/hubspot-logo-small.png';
import IntercomLogoSmall from 'img/intercom-logo-small.png';
import JiraLogo from 'img/jira-logo.svg';
import SlackLogo from 'img/landing/slack-logo.svg';
import LinearLogoSmall from 'img/linear-logo-small.png';
import MicrosoftTeamsLogoSmall from 'img/microsoft-teams-logo-small.png';
import OktaLogo from 'img/okta-logo-icon.png';
import OIDCLogo from 'img/open-id-connect-logo.png';
import OpenAILogo from 'img/openai-logo.png';
import ProductHuntLogo from 'img/product-hunt-logo-small.svg';
import SalesforceLogo from 'img/salesforce-logo-small.png';
import SalesforceTextLogo from 'img/salesforce-text-logo-small.svg';
import SegmentLogoSmall from 'img/segment-logo-small.png';
import ShopifyLogo from 'img/shopify-logo-small.svg';
import TLDVLogo from 'img/tldv-logo-small.svg';
import TrustpilotLogo from 'img/trustpilot-logo-small.svg';
import TrustRadiusLogo from 'img/trustradius-logo-small.svg';
import WordpressLogo from 'img/wordpress-logo-small.svg';
import ZapierLogo from 'img/zapier-logo-square-medium.png';
import ZendeskLogoSmall from 'img/zendesk-logo-small.png';
import ZoomLogoSmall from 'img/zoom-logo-small.png';
import { LinkIcon } from 'lucide-react';

const LogoMap: Partial<Record<IntegrationNames, string>> = {
  [IntegrationNames.asana]: AsanaLogo,
  [IntegrationNames.azure]: AzureLogo,
  [IntegrationNames.azureDevops]: AzureDevopsLogoSmall,
  [IntegrationNames.clickup]: ClickupLogo,
  [IntegrationNames.discord]: DiscordLogoSmall,
  [IntegrationNames.freshdesk]: FreshdeskLogo,
  [IntegrationNames.gitHub]: GitHubLogo,
  [IntegrationNames.gong]: GongLogoSmall,
  [IntegrationNames.helpscout]: HelpscoutLogoSmall,
  [IntegrationNames.hubspot]: HubspotLogoSmall,
  [IntegrationNames.intercom]: IntercomLogoSmall,
  [IntegrationNames.jira]: JiraLogo,
  [IntegrationNames.linear]: LinearLogoSmall,
  [IntegrationNames.microsoftTeams]: MicrosoftTeamsLogoSmall,
  [IntegrationNames.oidc]: OIDCLogo,
  [IntegrationNames.okta]: OktaLogo,
  [IntegrationNames.salesforce]: SalesforceLogo,
  [IntegrationNames.segment]: SegmentLogoSmall,
  [IntegrationNames.slack]: SlackLogo,
  [IntegrationNames.tldv]: TLDVLogo,
  [IntegrationNames.zapier]: ZapierLogo,
  [IntegrationNames.zendesk]: ZendeskLogoSmall,
  [IntegrationNames.zoom]: ZoomLogoSmall,
  [IntegrationNames.openai]: OpenAILogo,
  // Review integrations
  [IntegrationNames.appStoreReviews]: AppStoreLogo,
  [IntegrationNames.capterraReviews]: CapterraLogo,
  [IntegrationNames.g2Reviews]: G2Logo,
  [IntegrationNames.playStoreReviews]: GooglePlayLogo,
  [IntegrationNames.productHuntReviews]: ProductHuntLogo,
  [IntegrationNames.salesforceReviews]: SalesforceTextLogo,
  [IntegrationNames.shopifyReviews]: ShopifyLogo,
  [IntegrationNames.trustpilotReviews]: TrustpilotLogo,
  [IntegrationNames.trustradiusReviews]: TrustRadiusLogo,
  [IntegrationNames.wordpressReviews]: WordpressLogo,
};

type Props = {
  className?: string;
  integrationName: IntegrationNames | ManualSourceNames;
};

const IntegrationSourceLogo = ({ className, integrationName }: Props) => {
  const isManualSourceName = Object.values(ManualSourceNames).includes(
    integrationName as ManualSourceNames,
  );
  const logoSrc = LogoMap[integrationName as IntegrationNames];

  if (isManualSourceName || !logoSrc) {
    return <LinkIcon size={16} />;
  }

  return <LazyLoadedImage className={className} src={logoSrc} alt={integrationName} />;
};

export default IntegrationSourceLogo;
